import { InputLeftElement as ChakraInputLeftElement } from "@chakra-ui/react";

export const InputLeftElement = ChakraInputLeftElement;
